<template>
  <v-card class="oderon-card elevation-0">
    <OperationDetailsDialog ref="detailsDialog" />

    <v-toolbar>
      <v-toolbar-title>Histórico</v-toolbar-title>

      <v-btn icon class="ml-4" @click="reload">
        <v-icon>mdi-refresh</v-icon>
      </v-btn>

      <ODateRangeButton
        class="mx-8"
        type="form-input"
        width="350px"
        v-model="dateRange"
      />

      <v-spacer />

      <!-- <v-btn icon @click="checkDownload" title="Exportar para Excel">
        <v-icon>mdi-microsoft-excel</v-icon>
      </v-btn> -->
    </v-toolbar>

    <OLoadingLine absolute :value="isLoading" />

    <ODataGrid
      v-if="gridData != null"
      class="maxh-full-4"
      :data="gridData"
      :limit.sync="limit"
      :offset.sync="offset"
      @rowClicked="showDetailsDialog"
    />
  </v-card>
</template>

<script>
import { ClientHistory } from '@/models'
import ODataGrid from 'oderon-vue/cpts/ODataGrid'
import PaginatedReportMixin from 'oderon-vue/cpts/PaginatedReportMixin'
import OperationDetailsDialog from '../../clients/operations/OperationDetailsDialog.vue'
import utils from 'oderon-commons/src/utils'

export default {
  mixins: [PaginatedReportMixin],
  components: { ODataGrid, OperationDetailsDialog },
  props: {
    row: { required: true }
  },
  data() {
    return {
      isLoading: false,
      offset: 0,
      limit: 5,
      gridData: null,

      dateRange: [null, null]
    }
  },
  computed: {
    filterParams() {
      return {
        technicianIds: this.row.id,
        fromDate: this.dateRange[0],
        untilDate: this.dateRange[1]
      }
    },
    apiParams() {
      return utils.clearEmptyValues({
        ...this.filterParams,
        offset: this.offset,
        limit: this.limit,
        order: this.order
      })
    }
  },
  mounted() {
    this.reload()
  },

  methods: {
    reload() {
      this.$loading(() => this.fetchData())
    },

    async fetchData() {
      this.gridData = await ClientHistory.getGrid(this.apiParams)
    },

    async showDetailsDialog(row) {
      let res = await this.$refs.detailsDialog.open({
        historyId: row.id
      })

      if (res === 'RELOAD') {
        this.$loading(() => this.fetchData())
      }
    }
  }
}
</script>

<style></style>
